import TextArea from 'components/text-area';
import style from './style.module.scss';
import Button from 'components/button';
import useFavoriteNote from 'api/hooks/use-favorite-note-patch';
import { useEffect, useState } from 'react';
import useFavoriteNoteById from 'api/hooks/use-favorite-note-by-id';
import Loader from 'components/loader';
import useBoundStore from 'store';
interface IFavoriteNoteForm {
  facilityId: number;
  favoriteListId: number;
  refetchList: () => void;
  onDismiss: () => void;
}

const FavoriteNoteForm = ({
  facilityId,
  favoriteListId,
  refetchList,
  onDismiss,
}: IFavoriteNoteForm) => {
  const { data: dataNote, isLoading } = useFavoriteNoteById(favoriteListId, facilityId);
  const [currentNote, setCurrentNote] = useState<string | null>(null);
  const { isMutating, trigger } = useFavoriteNote(facilityId, favoriteListId, currentNote);
  const setIsShowKeyBoardHeight = useBoundStore((s) => s.setIsShowKeyBoardHeight);

  useEffect(() => {
    if (dataNote?.note) {
      setCurrentNote(dataNote?.note);
    }
  }, [dataNote?.note]);

  const handleSent = async () => {
    if (facilityId && favoriteListId) {
      await trigger();
      await refetchList();
      onDismiss();
    }
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div className={style.container}>
      <div className={style.textArea}>
        <TextArea
          onChange={setCurrentNote}
          value={!currentNote ? '' : currentNote}
          placeholder='Зафиксируйте информацию здесь'
          onFocus={() => setIsShowKeyBoardHeight(true)}
          onBlur={() => setIsShowKeyBoardHeight(false)}
        />
      </div>

      <div className={style.buttons}>
        <Button label='Отменить' variant='gray' onClick={onDismiss} />
        <Button label='Сохранить' onClick={handleSent} loading={isMutating} />
      </div>
    </div>
  );
};

export default FavoriteNoteForm;
